import React from "react";

import PropTypes from "prop-types";

export const SpinnerSize = {
    Big: "Big",
    Medium: "Medium",
    Small: "Small"
};

const Spinner = (props) => {
    let sizeClassname = "spinner-border-sm";
    if (props.size === SpinnerSize.Big) {
        sizeClassname = "spinner-border-xl";
    } else if (props.size === SpinnerSize.Medium) {
        sizeClassname = "spinner-border-md";
    }

    /* Size: user spinner-border-sm, spinner-border-lg */
    return (
        <div className={"spinner-border text-primary " + sizeClassname} role="status" />
    );
};

Spinner.defaultProps = {
    size: SpinnerSize.Small,
    color: "text-primary"
}

Spinner.propTypes = {
    size: PropTypes.oneOf(Object.keys(SpinnerSize)),
    color: PropTypes.string
};

export default Spinner;